import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterstatus',
  pure: false,
})
export class FilterStatusPipe implements PipeTransform {
  transform(value, [term]) {
    if (value && value.length && term !== 'default') {
      const val = value.filter(item => {
        return this.search(item, [term]);
      });

      return val;
    }
    return value;
  }

  private search(item, [term]) {
    if (typeof item.status !== 'undefined') {
      return item.status === term;
    } else {
      return item.application.status === term;
    }
  }
}
